import {Component, OnInit} from '@angular/core';
import {ReasonService} from "../../services/reason.service";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {Router} from "@angular/router";
import {PBSelectUser, PBTopic, PocketbaseService} from "../../services/pocketbase.service";
import {Reason} from "../../entities/reason";

@Component({
  selector: 'app-create-reason',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './create-reason.component.html',
  styleUrl: './create-reason.component.css'
})
export class CreateReasonComponent implements OnInit{
  title = new FormControl('');
  description = new FormControl('');

  topic?: String;
  users: PBSelectUser[] = []
  selectedUser?: PBSelectUser;
  topics: PBTopic[] = []

  constructor(private reasonService: ReasonService, private router: Router, private pocket: PocketbaseService) {
  }
  save(){
    document.getElementById('updateProductModal')?.click();
    if (this.selectedUser===undefined){
      this.selectedUser = {id:"", username:"Jeder", avatar:""}
    }
    this.reasonService.postReason({
      title: this.title.value?.toString() ?? "",
      description: this.description.value?.toString() ?? "",
      topic: this.topic ?? "",
      id:  ""
    }, this.selectedUser!)
    this.router.navigate(["/reason-board"])
  }

  ngOnInit(): void {
    this.pocket.getAllUser().then(p=>{
      this.users = p;
    })

    this.pocket.getAllTopics().then(p=>{
      this.topics = p;
    })

    this.reasonService.getReasonsCreatedFromMe().then(reasons=>{
      reasons.forEach(reason=>{
        this.reasonService.getTopic(reason.topic).then(topic => {
          reason.topic = topic?.topicname ?? ""
        })
      })
      this.reasons=reasons
    });
  }

  selectChange( $event : any) {
    this.selectedUser = this.users.find(p=>p.username == $event.target.value);
  }

  selectTopicChange($event: any) {
    this.topic = this.topics.find(p=>p.topicname==$event.target.value)?.id ?? ""
  }

  reasons: Reason[] = [];

  openReason(id: String) {
    this.reasonService.openReason(id)
  }
}
